module.exports = __webpack_public_path__ + "img/44.cd332d1a.png";